/* projects/speaker-platform/src/app/molecules/text-list-item/text-list-item.component.scss */
.textlistitem {
  margin-bottom: 16px;
  padding: 12px 12px 6px 12px;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1607843137);
  background-color: #fff;
  border-radius: 10px;
}
.textlistitem--standby {
  opacity: 0.5;
}
.textlistitem__excerpt {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  column-gap: 10px;
}
.textlistitem__excerpt__ref {
  grid-area: 1/1/2/2;
}
.textlistitem__excerpt__phasevocale {
  grid-area: 1/2/2/4;
}
.textlistitem__excerpt__text {
  grid-area: 1/4/2/9;
}
.textlistitem__excerpt__phonetic {
  grid-area: 1/7/2/9;
}
.textlistitem__excerpt__provisoire {
  grid-area: 1/9/2/10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.textlistitem__more button {
  background: none;
  border: 0;
  width: 100%;
  font-size: 22px;
}
.textlistitem__details {
  background-color: #FAF8F4;
  margin: 0 -12px;
}
.textlistitem__detailscontent {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr max-content max-content;
  column-gap: 40px;
  row-gap: 16px;
  padding: 32px 12px;
}
.textlistitem__detailscontent__text {
  grid-area: 1/1/3/3;
}
.textlistitem__detailscontent__phonetic {
  grid-area: 1/3/2/4;
}
.textlistitem__detailscontent__order {
  grid-area: 2/3/3/4;
}
.textlistitem__detailscontent__actions {
  grid-area: 3/1/4/4;
}
.textlistitem__detailscontent__nophonetic {
  font-style: italic;
}
.textlistitem.textlistitem--translate .textlistitem__excerpt__text {
  grid-area: 1/3/2/8;
}
.textlistitem.textlistitem--translate .textlistitem__detailscontent {
  grid-template-columns: repeat(2, 1fr);
}
.textlistitem.textlistitem--translate .textlistitem__detailscontent__text {
  grid-area: 1/1/2/2;
}
.textlistitem.textlistitem--translate .textlistitem__detailscontent__translatezone {
  grid-area: 1/2/2/3;
}
.textlistitem.textlistitem--translate .textlistitem__detailscontent__translatezone textarea {
  height: 100%;
  min-height: 250px;
}
.textlistitem.textlistitem--translate .textlistitem__detailscontent__order {
  grid-area: 2/1/3/2;
}
/*# sourceMappingURL=text-list-item.component-3WEPNIHM.css.map */
